import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {IBaseComponent} from '../../components/ibase/ibase.component';
import {TreeNode} from 'primeng/api';

/**
 * Base data cell display component
 */
@Component({
    template: ''
})
export abstract class IDataCellDisplayComponent<t_Type, t_ExtraType> extends IBaseComponent implements OnChanges {
    @Input()
    public displayType!: 'table' | 'tree';
    @Input()
    public rows!: t_Type[] | TreeNode<t_Type>[];
    @Input()
    public row!: t_Type | TreeNode<t_Type>;
    @Input()
    public attribute!: string;
    @Input()
    public extra?: t_ExtraType;
    @Input()
    public value?: unknown;

    // ===============================================================
    // ===============================================================

    /**
     * On init
     */
    public override async ngOnInit() {
        this.showLoading = true;
    }
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
    /**
     * On attribute change
     * @param changes Changed attributes
     */
    public ngOnChanges(changes: SimpleChanges) {
        // Re‑compute anything that depends on row (value modifiation is triggered by row modification)
        if (changes['row']) {
            this.refresh();
        }
    }

    // ===============================================================
    // ===============================================================

    /**
     * Refresh
     */
    public async refresh(): Promise<void> {
        this.showLoading = true;
        this.showError = false;

        try {
            await this.onRefresh();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            this.globalsService.messageService.add({
                key: this.overrideMessagesKey,
                severity: 'error',
                detail: 'Error while refreshing: ' + (err?.error?.message ?? err.toString())
            });

            // Log error in the console for debugging, do not remove
            console.log(err);

            this.showError = true;
        }

        this.showLoading = false;
    }
    /**
     * On refresh (Error handling and refresh is done in the parent)
     */
    protected abstract onRefresh(): Promise<void>;
}
